module.exports = __webpack_public_path__ + "img/share.75e86130.png";